import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowTopRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16.95 7.05-9.9 9.9M10 7l6.95.049L17 14"
    />
  </svg>
);
export default SvgArrowTopRight;
